import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

Vue.config.productionTip = false

// Import Libraries
import api from '@/apis'

// Init Libraries
Object.defineProperty(Vue.prototype, '$api', { value: api })

Vue.use(VueTelInput)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
